<div (click)="handleClick()" class="simple-card-status">
  <div class="card-title-wrapper">
    <p>{{ title }}</p>
    <div class="card-tooltip-container" *ngIf="tooltip">
      <svg
        class="icon-info"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="10"></circle>
        <path d="M12 16v-4"></path>
        <path d="M12 8h.01"></path>
      </svg>
      <div class="card-tooltip-balloon" [innerHTML]="tooltip"></div>
    </div>
  </div>
  <h4>
    {{ quantity }}
  </h4>
</div>
